export default __webpack_public_path__ + "72dd7ab16ceb6e392cbff772e928387e.png";